<!--
 * @Description: 省份模板管理-弹框
 * @Author: 
 * @Date: 2022-12-28 11:41:16
 * @LastEditTime: 2024-03-11 17:34:11
 * @LastEditors: Jky200guo guohongyuan@jiankeyan.com
 * @Usage: 
-->

<template>
  <el-dialog
    title="查看"
    :visible.sync="addDialogVisible"
    width="30%"
    center
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="box">
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="140px"
        :rules="rules"
      >
        <el-row>
          <el-col>
            <el-form-item
              label="公司/项目名称:"
              prop="name"
            >
              <el-input
                disabled
                v-model="form.name"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              label="类别:"
              prop="specificTypeName"
            >
              <el-input
                disabled
                v-model="form.specificTypeName"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              label="状态:"
              prop="isEnable"
            >
              <el-select
                :disabled="!isEdit"
                v-model="form.isEnable"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="pro in  options"
                  :key="pro.value"
                  :label="pro.label"
                  :value="pro.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              label="定制化地址:"
              prop="actionUrl"
            >
              <el-input
                maxlength="40"
                :disabled="!isEdit"
                v-model="form.actionUrl"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            class="dialog-footer"
            style="text-align: center;"
          >
            <el-button
              v-if="isEdit"
              @click="close"
            >取 消</el-button>
            <el-button
              v-if="!isEdit"
              @click="isEdit=true"
            >编 辑</el-button>
            <el-button
              type="primary"
              @click="submit('ruleForm'); "
            >确 定</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- </div> -->
  </el-dialog>
</template>
  
  <script>
import _ from 'lodash'
import { BASE_URL } from '@/util/constant'
import { Api_SuperAdmin } from "@/api/api";
export default {
  mixins: [],
  data() {
    return {
      isEdit: false,
      options: [{ value: true, label: '启用' }, { value: false, label: '禁用' },],
      addDialogVisible: false,
      form: {
        "id": 0,
        "authorityCompanyId": 0,
        "authorityProjectId": 0,
        "specificType": 0,
        "specificTypeName": "",
        "actionUrl": "",
        "isEnable": true,
        "name": ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入公司/项目名称",
          trigger: "blur",
        }],
        specificTypeName: [{
          required: true,
          message: "请输入类别",
          trigger: "blur",
        }],
        isEnable: [{
          required: true,
          message: "请选择状态",
          trigger: "blur",
        }],
        actionUrl: [{
          required: true,
          message: "请输入定制化地址",
          trigger: "blur",
        }],
      },
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      baseUrl: BASE_URL,
    };
  },
  components: {
  },
  created() {
  },
  methods: {
    close() {
      this.clear()
      this.addDialogVisible = false
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api_SuperAdmin.saveCustomized(this.form).then((res) => {
            const { data } = res
            if (data.statusCode === 200) {
              this.$message({
                type: "success",
                message: "保存成功!",
              });
              this.$emit('updateList')
              this.close()
            } else {
              this.$showMessage("失败", data.errors);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },
    getDetail(data) {
      Api_SuperAdmin.getCustomizedDetail(data.id).then((res) => {
        const result = res.data;
        if (result.statusCode == 200) {
          this.form = { ...result.data }
        }
      });
    },
    open(data) {
      this.addDialogVisible = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields();
      }
      this.clear()
      this.getDetail(data)
      this.isEdit = false
    },
    clear() {
      this.menuList = []
      this.form = {
        "id": 0,
        "authorityCompanyId": null,
        "authorityProjectId": null,
        "specificType": 1,
        "actionUrl": "",
        "isEnable": true
      }
      this.editId = 0
      this.tableData = []
      this.isGroupEdit = false
      this.showSaveBtn = false
    },
  },
};
  </script>
  <style lang="scss" scoped>
.home-img {
  height: 55px;
}
.container {
  margin-top: 20px;
  .box {
    padding: 20px;
    border: 1px solid #365f7d;
    margin: 10px 0 20px;
  }

  .inner-box {
    border: 1px solid #365f7d;
    padding: 10px;
  }

  .check-all {
    display: flex;
    align-items: flex-start;
  }
}
#nav-bar {
  width: 100%;
  text-align: center;
  .nav {
    padding: 20px 0;
    padding-left: 10px;
    box-sizing: border-box;
    overflow-x: auto;
    white-space: nowrap;
    span {
      // width: 140px;
      // height: 40px;
      padding: 10px 10px;
      line-height: 40px;
      text-align: center;
      margin-right: 20px;
      background: #22386d;
      color: #61d2f7;
      font-size: 14px;
      font-weight: bold;
      word-break: keep-all;
      cursor: pointer;
    }
    .en {
      padding: 10px 2px;
      margin-right: 4px;
    }
    .active {
      background: #2f65ec !important;
    }
  }
}
::v-deep.el-input.is-disabled .el-input__inner {
  border-color: #365f7d;
  color: #c0c4cc;
  background-color: #092963;
  border-radius: 2px;
}
::v-deep.el-select .el-input.is-disabled .el-input__inner {
  border-color: #365f7d;
  color: #c0c4cc;
  background-color: #092963;
  border-radius: 2px;
}
</style>